import type { Item } from "~/components/categorySwiper/CategorySwiper"
import SwiperItem from "~/components/categorySwiper/Swiper/Item"
import Slider from "~/components/categorySwiper/Swiper/Swiper"
import { useSignal } from "~/sdk/signal"

interface Props {
    items: Item[]
}

export default function SwiperWrapper({ items }: Props) {
    const slide = useSignal(3)
    const animate = useSignal(true)
    const firstItems = items.slice(0, 2)
    const lastItems = items.slice(-2)
    const itemsWithClones = [...lastItems, ...items, ...firstItems]

    return (
        <div className='py-2 flex lg:py-4'>
            <Slider length={itemsWithClones.length} slide={slide} animate={animate}>
                {itemsWithClones.map((item, index) => (
                    <SwiperItem index={index} item={item} slide={slide} animate={animate} />
                ))}
            </Slider>
        </div>
    )
}
